import { connect } from 'react-redux'
import { camelCase } from 'lodash'
import ruleActions from '../../actions/PlanSharedBusinessRules'

import PlanSharedBusinessRulesShow from './PlanSharedBusinessRulesShow'

export function connectPlanSharedBusinessRules(productLine, showAction, resetAction, generic = false) {
  const benefitsSetName = generic ? 'genericBenefitsSets' : `${camelCase(productLine)}BenefitsSets`

  const mapStateToProps = (state) => {
    const planStateShow = state[benefitsSetName].show
    const rulesStateShow = state.planSharedBusinessRules.show
    const configuration = state.login.session.configuration.benefits

    return {
      benefitsSet: planStateShow.attributes,
      businessRules: rulesStateShow.attributes,
      configuration,
      productLine
    }
  }

  const mapDispatchToProps = {
    show: showAction,
    rulesShow: ruleActions.show.main,
    reset: resetAction
  }

  return connect(mapStateToProps, mapDispatchToProps)(PlanSharedBusinessRulesShow)
}

export default connectPlanSharedBusinessRules
